import React from "react";
import { PageHeader } from "../components/PageHeader";
import { Contact } from "../components/Contact";
import { useLang } from "../context/LanguageContext";

export default function ContactPage() {
  const { t } = useLang();
  return (
    <div className="bg-white" data-testid="contact-page">
      <PageHeader label={t.contact.overline} title={t.pages.contactTitle} subtitle={t.pages.contactSub} />
      <Contact />
    </div>
  );
}
